import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import { Key, ArrowRight } from "lucide-react";
import { API } from "../constants";
import { useAuth } from "../context/AuthContext";

export const ForcePasswordChangePage = () => {
  const { user, logout, refreshUser } = useAuth();
  const navigate = useNavigate();
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (newPassword !== confirmPassword) {
      toast.error("Las contraseñas no coinciden");
      return;
    }
    if (newPassword.length < 6) {
      toast.error("La contraseña debe tener al menos 6 caracteres");
      return;
    }

    setLoading(true);
    try {
      await axios.post(`${API}/auth/reset-password`, {
        email: user.email,
        new_password: newPassword
      });
      toast.success("Contraseña actualizada correctamente");
      await refreshUser();
      navigate("/");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Error al cambiar contraseña");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="glass rounded-2xl p-8">
          <div className="text-center mb-8">
            <div className="w-16 h-16 bg-amber-500/20 rounded-full flex items-center justify-center mx-auto mb-4">
              <Key size={32} className="text-amber-500" />
            </div>
            <h1 className="text-2xl font-bold mb-2">Cambio de Contraseña Requerido</h1>
            <p className="text-zinc-400">
              El administrador ha solicitado que cambies tu contraseña para continuar.
            </p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="form-label">Nueva Contraseña</label>
              <input
                type="password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                className="form-input"
                placeholder="Mínimo 6 caracteres"
                required
                minLength={6}
                data-testid="new-password-input"
              />
            </div>
            <div>
              <label className="form-label">Confirmar Nueva Contraseña</label>
              <input
                type="password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                className="form-input"
                placeholder="Repite la nueva contraseña"
                required
                data-testid="confirm-password-input"
              />
            </div>

            <button
              type="submit"
              disabled={loading}
              className="w-full py-3 bg-amber-500 text-black font-semibold rounded-xl hover:bg-amber-400 transition-colors flex items-center justify-center gap-2 disabled:opacity-50"
              data-testid="save-password-btn"
            >
              {loading ? "Guardando..." : (
                <>
                  Guardar y Continuar <ArrowRight size={20} />
                </>
              )}
            </button>
          </form>

          <button
            onClick={logout}
            className="w-full mt-4 py-2 text-zinc-400 hover:text-red-400 transition-colors text-sm"
          >
            Cerrar sesión
          </button>
        </div>
      </div>
    </div>
  );
};

export default ForcePasswordChangePage;
